import { formatRoute, ROUTE_ARROW, type RouteFields } from '../../utils/routeLabel';
import styles from './RouteText.module.css';

interface RouteTextProps {
  /** Shipment-like route fields, or an already built "City, ST → City, ST" label. */
  route: RouteFields | string;
  /** Detail-header form ("City, State name"); ignored when `route` is a string. */
  long?: boolean;
  className?: string;
}

/**
 * A trip's from → to, shown in full everywhere (never cut off with "…").
 * Each end is kept together, so when the column is narrow the label wraps between
 * "Hyderabad, Telangana" and "→ Guwahati, Assam" instead of mid-name; a single end
 * wider than the column still wraps rather than overflowing.
 */
export function RouteText({ route, long, className }: RouteTextProps) {
  const label = typeof route === 'string' ? route : formatRoute(route, { long });
  const at = label.indexOf(ROUTE_ARROW);
  const cls = className ? `${styles.route} ${className}` : styles.route;
  if (at < 0) return <span className={cls}>{label}</span>;
  const from = label.slice(0, at);
  const to = label.slice(at + ROUTE_ARROW.length);
  return (
    <span className={cls} aria-label={label}>
      <span className={styles.end}>{from}</span>{' '}
      <span className={styles.end}>→ {to}</span>
    </span>
  );
}
